import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import moment from 'moment'
import Title from '../general/title'
import helpers from "helpers/helpers"
import getData from 'helpers/submitData'
import { loadingStatus } from 'actions'
import FullTable from "components/FullTable"
import currentUser from "helpers/currentUser"

class BuilderPortalActivity extends Component {

	constructor(props) {
		super(props)
		this.state = {
			rows: [],
			sorted: [],
			filtered: [],
		}
		this.user = currentUser()
	}

	componentDidMount() {
		this.props.loadingStatus(false)
		if(this.user.super) {
			getData("getActivity", { dates: this.props.currentDates, properties: this.props.activeProperties })
				.then((resp) => {
					this.setState({ rows: resp.data })
				})
				.catch((e) => {
					console.log(e)
				})
		}
	}

	componentDidUpdate(prevProps) {
		if(prevProps !== this.props && this.user.super) {
			getData("getActivity", { dates: this.props.currentDates, properties: this.props.activeProperties })
				.then((resp) => {
					this.setState({ rows: resp.data })
					this.props.loadingStatus(false)
				})
				.catch((e) => {
					console.log(e)
				})
		}
	}

	countActions = (id) => {
		var count = 0
		this.props.payload.activity.forEach((r) => {
			if(id == r.user) {
				count++
			}
		})

		return count
	}

	buildTable = () => {
		let ret = []
		_.forEach(this.state.rows, v => {
			let b = _.find(this.props.payload.public.builders, {id: v.builder})
			let c = _.find(this.props.payload.public.properties, {id: v.property})
			if(!b) { b = {name: ''} }
			ret.push({
				user: `${v.first} ${v.last}`,
				builder: b.name,
				date: v.addedDate,
				type: v.type,
				community: c && c.name || '',
				action: v.excerpt
			})
		})

		return ret
	}

	createTable = () => {
		const columns = [
			{
				Header: "User",
				accessor: "user",
				filterMethod: (f, r) => helpers.tableText(f, r, "user"),
			},
			{
				Header: "Type",
				accessor: "type",
				filterMethod: (f, r) => helpers.tableText(f, r, "type"),
			},
			{
				Header: "Info",
				accessor: "action",
				filterMethod: (f, r) => helpers.tableText(f, r, "action"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "Community",
				accessor: "community",
				filterMethod: (f, r) => helpers.tableText(f, r, "community"),
			},
			{
				Header: "Date",
				accessor: "date",
				Cell: (v) => {
					return moment.unix(v.value).format("MM/DD/YY LT")
				},
				filterMethod: (f, r) => helpers.dateFilter(f, r),
			},
		]
		return (
			<div className="content">
				<FullTable
					data={this.buildTable()}
					columns={columns}
					name="activity__builderPortal"
					title="Builder Portal Activity"
					defaultSorted={[
						{
							id: "date",
							desc: true,
						},
					]}
				/>
			</div>
		)
	}

	render() {

		return (
			<div className="sales">
				<div className="imageGroup">
					<Title title="Builder Portal Activity" />
					{this.createTable()}
				</div>
			</div>
		)
	}

}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
        compareDates: state.compareDates,
		payload: state.payload,
		activeProperties: state.activeProperties
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({
		loadingStatus
	}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(BuilderPortalActivity)